import { MatSpinner } from '@angular/material/progress-spinner';
import { ChangeDetectionStrategy, Component, ElementRef, Inject, inject, LOCALE_ID, model, signal, ViewChild } from '@angular/core';
import { ListItem, ModalListItemI, Stock, GarantieI, Prime, TarificationCheck, ListeDocs, Vehicule, Assure, Assurance, PrintData } from '../../../shared/model';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { formatDate, NgIf, UpperCasePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ToastrService } from '../../../shared/services/toastr-service';
import { SweetAlertService } from '../../../shared/services/sweet-alert-service';
import { HttpClient } from '@angular/common/http';
import { AssuranceService } from '../../service/assurance-service';
import { ListModalComponent } from '../../../shared/components/list-modal-component/list-modal-component';
import { ListComponent } from "../../../shared/components/list-component/list-component";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PdfService } from '../../../shared/services/pdf-service';
import { fromEvent, throttleTime } from 'rxjs';
import * as introJs from 'intro.js'
import { VehiculeComponentModal } from './modal-vehicule';
import { Moment } from 'moment';
import { checkDateEffet } from '../../../shared/validators';
import { DateMaskDirective } from "../../../shared/Directive/DateMask";
import { PrintComponent } from '../../../shared/components/print-component/print-component';

export interface ModalDataI{
  title : string,
  update ?: boolean,
  data ?: Vehicule,
  assurance ?: any,
  assurance_id ?: string,
  categorie ?: string,
  zone ?: string,
  periode ?: number,
  compagnie_id ?: string,
  compagnie_name ?: string,
  assure ?: Assure,
  garanties ?:GarantieI[],
}

@Component({
  selector: 'app-assurance-modal',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatDatepickerModule,
    MatIcon,
    ListComponent,
    MatChipsModule,
    MatCheckboxModule,
    MatTooltip,
    MatSpinner,
    UpperCasePipe,
    MatDatepickerModule,
    DateMaskDirective
],
  templateUrl: '../modal/modal-assurance.html',
  styleUrl: '../modal/modal-assurance.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssuranceComponentModal {
  readonly dialogRef = inject(MatDialogRef<VehiculeComponentModal>);

  // recupere les donnees envoyes par le parent
  readonly inputData = inject<ModalDataI>(MAT_DIALOG_DATA);

  readonly vehicule = model(this.inputData.data!);

  assuranceForm : FormGroup = new FormGroup({})

  readonly dialog = inject(MatDialog);

  dataOrigin !: ListeDocs

  compagniesListe : Array<ListItem> = []
  currentCompagnie !: {compagnie_id : string, compagnie_name : string, compagnie_code : string}

  typeListeOrigine : Array<{type : string, compagnie_id : string}> = []
  typeListe : Array<{type : string, compagnie_id : string}> = []

  stocks : Stock[] = []
  currentStock : Stock[] = []
  attestationList : ListItem[] = []
  carteRoseList : ListItem[] = []
  garantieList = signal<ListItem[]>([])

  garanties : GarantieI[] = []
  selectedGarantie : GarantieI[] = []
  selectedGarantieOrigin : GarantieI[] = []

  zones : string[] = ["A", "B", "C"]

  energies : string[] = ["ESSENCE", "DIESEL"]

  loading : boolean = false
  loadingPrevu = signal<boolean>(false)
  saveLoading = signal<boolean>(false)
  dataCalculPrime = signal<Prime>(new Prime)
  windowScrolledBottom = true
  windowScrolledTop = false

  currentAssuranceId : string =''
  //remorque = signal<boolean>(false)

  showDetailsGarantie = signal(false)

  remorqueCat = [1, 2, 3, 5, 9]

  @ViewChild('modalDialog') modalDialog !: ElementRef

  prevu : boolean = false

  constructor(
    private fb : FormBuilder,
    private toastr : ToastrService,
    private assuranceService : AssuranceService,
    private http : HttpClient,
    private pdfService : PdfService,
    @Inject(LOCALE_ID) private locale : string,
    private sweetAlert : SweetAlertService
  ){

  }

  ngOnInit(): void {
    //this.remorque.update(val => this.inputData.remorque??false)
      this.initForm()
      if(this.inputData.data?.remorque && !this.inputData.data?.tracteur_id){
        this.assuranceForm.get('puissance')?.setValidators([Validators.required, Validators.min(1)])
        this.assuranceForm.get('energie')?.setValidators(Validators.required)
      }else{
        this.assuranceForm.get('puissance')?.setErrors(null)
        this.assuranceForm.get('energie')?.setErrors(null)

        //verification de la vignette aucour de l'annee
        this.assuranceService.checkVignette(this.inputData.data?.id! || this.inputData.assurance?.vehicule).subscribe({
          next : (res) =>{
            if(res){
              this.assuranceForm.get('vignette_paye')?.setValue(true)
              this.assuranceForm.get('vignette_paye')?.disable()
            }
          }
        })
      }
      this.loadDocuments()
      this.loadGarantie()

  }

  ngAfterViewInit(): void {

    this.assuranceForm.get('compagnie_id')?.valueChanges.subscribe((val) =>{
      const catControl = this.assuranceForm.get('categorie') as FormControl
        if(val != ''){
          if(!catControl?.enabled)
              catControl?.enable()
        }

        if(catControl?.value!=''){
          this.onSetType(catControl.value)
        }
    })

    this.assuranceForm.get('categorie')?.valueChanges.subscribe((val : number) =>{
      const categories = [4, 5, 6, 7, 8, 9, 10]

        if(categories.findIndex(item => item == val) != -1){
          setTimeout(() => {
            const introjs = introJs.default()
            introjs.setOptions({
              steps :[
                {
                  element : document.querySelector('.detailsCategorie'),
                  intro : 'Veuillez cocher les options de la categorie '+val,
                  position : 'right',
                }
              ]
            }).start()
          }, 500);
        }
    })

    this.assuranceForm.get('date_effet')?.valueChanges
    .subscribe((val) =>{
      const periode = this.assuranceForm.get('periode')?.value
      this.setEndDate(periode)
    })

    fromEvent(this.modalDialog.nativeElement, 'scroll')
    .pipe(throttleTime(100))
    .subscribe(() => this.onWindowScrolled())

    console.log(this.modalDialog.nativeElement.scrollTop);
  }


  onWindowScrolled(){
    const content = this.modalDialog.nativeElement

    this.windowScrolledTop = content.scrollTop > 0

    this.windowScrolledBottom = content.scrollHeight >= content.clientHeight - content.scrollTop
  }

  scrollToTop(){
    const content = this.modalDialog.nativeElement
    content.scrollTo({
      top: 0,
      behavior : 'smooth'
    })
  }

  scrollToBottom(){
    const content = this.modalDialog.nativeElement
    content.scrollTo({
      top: content.scrollHeight,
      behavior : 'smooth'
    })
  }

  initForm(){
      this.assuranceForm = this.fb.group({
      compagnie_id : ['', [Validators.required]],
      compagnie_name : [''],
      type : ['', [Validators.required]],
      type_name : [''],
      attestation : ['', [Validators.required]],
      carte_rose : ['', [Validators.required]],
      stock_attestation : ['', [Validators.required]],
      stock_carte_rose : ['', [Validators.required]],
      partenaire : ['', [Validators.required]],
      categorie : [{value : '', disabled : true}, [Validators.required]],
      zone : ['', [Validators.required]],
      date_effet : ['', [Validators.required, checkDateEffet]],
      periode : [0, [Validators.required, Validators.min(1)]],
      date_fin : ['', [Validators.required]],
      reduction : [0, [Validators.required]],
      puissance : [0],
      cylindree : [0],
      energie : [''],
      vignette_exonere : [false],
      vignette_paye : [false],
      licence_transport : [false],
        //
      detailsCat7 : this.fb.group({
        tourisme : false,
        utilitaire : false,
        deuxTroisRoues : false,
        //
        doubleCom : false,
        rce : false
        //
      }),
      detailsCat5 : this.fb.group({
        commercial : false
      }),
      //
      detailsCat6 : this.fb.group({
        nbre_carte : [1, [Validators.min(1), Validators.max(5)]],
        tarif1 : true
      }),
      //
      detailsCat8 : this.fb.group({
        utilitaire : false,
        location : false,
        moins3_5t : false,
        plus3_5t : false
      }),
      detailsCat9 : this.fb.group({
        manutention : false,
        portuaire : false
      }),
      detailsCat10 : this.fb.group({
        categorie10a : false,
        collectivite : false,
        tracteur : false,
        //
        ambulance : false,
        corbillard : false,
        fourgon : false,
        //
        poidsSuperieur : false,
        poidsInferieur : false
      }),
      //
      conducteur : this.fb.group({
        lieu_delivrance : [''],
        date_delivrance : [''],
        num_permis : [''],
        birthday : [''],
        genre : [this.inputData.assure?.gender, [Validators.required]],
        name : [(this.inputData.assure?.firstname)?this.inputData.assure?.firstname+" "+this.inputData.assure?.lastname:this.inputData.assure?.representant, [Validators.required]],
      }),
      valeurs : this.fb.group({
        valeur_neuve : 0,
        valeur_venale : 0
      }),
      garantie : this.fb.group({
        rc : false,
        dr : false,
        ipt : false,
        dta : false,
        dpc : false,
        bdg : false,
        vp : false,
        bra : false,
        vol : false,
        inc : false,
        ar : false
      })
      })
  }

  loadDocuments(){
      this.loading = true
      this.assuranceService.listeDocumenst().subscribe({
        next : (res) =>{
          console.log(res);
          this.dataOrigin = res
          this.compagniesListe.push(...(res.compagnies.map(item => {return {id : item.compagnie_id, name : item.compagnie_name}})))
          this.typeListeOrigine.push(...(res.types))
          this.stocks.push(...res.stocks.slice())

          //avenant de renouvellement
          if(this.inputData.update){
              this.assuranceForm.patchValue(this.inputData?.assurance!)
              //this.assuranceForm.get('assure_id')?.setValue(this.inputData.assurance.assure)
              this.currentAssuranceId = this.inputData?.assurance.id
              this.assuranceForm.get('reduction')?.setValue(this.inputData.assurance.reduction)
              this.assuranceForm.get('categorie')?.enable()
              const comp = this.assuranceForm.get('compagnie_id')?.value
              this.currentCompagnie = (this.dataOrigin.compagnies.filter(item => item.compagnie_id ==  comp))[0]
              console.log(this.inputData.assurance);
              this.onSetType(this.assuranceForm.get('categorie')?.value)
          }

          //assurance remorque tractee
          if(this.inputData.data?.remorque && this.inputData.data.tracteur_id){
            this.loading = true
            this.assuranceService.getAssurance(this.inputData.data.tracteur_id!).subscribe({
              next : (assurance) =>{
                console.log(assurance);
                //infos de l'assurance du tracteur
                this.currentCompagnie = res.compagnies.filter(item => item.compagnie_id == assurance.compagnie_id)[0]
                this.assuranceForm.get('compagnie_name')?.setValue(this.currentCompagnie?.compagnie_name)
                this.assuranceForm.get('compagnie_id')?.setValue(this.currentCompagnie?.compagnie_id)
                this.assuranceForm.get('zone')?.setValue(assurance.zone)
                this.assuranceForm.get('categorie')?.setValue(assurance.categorie)
                this.assuranceForm.get('date_effet')?.setValue(assurance.date_effet)
                this.assuranceForm.get('periode')?.setValue(assurance.periode.toString())
                this.assuranceForm.get('date_fin')?.setValue(assurance.date_fin)
                this.onSetType(assurance.categorie)
                //infos du conducteur tracteur
                this.assuranceForm.get('conducteur')?.get('name')?.setValue(assurance.conducteur?.name)
                this.assuranceForm.get('conducteur')?.get('birthday')?.setValue(assurance.conducteur?.birthday)
                this.assuranceForm.get('conducteur')?.get('lieu_delivrance')?.setValue(assurance.conducteur?.lieu_delivrance)
                this.assuranceForm.get('conducteur')?.get('genre')?.setValue(assurance.conducteur?.genre)
                this.assuranceForm.get('conducteur')?.get('num_permis')?.setValue(assurance.conducteur?.num_permis)
                this.assuranceForm.get('conducteur')?.get('date_delivrance')?.setValue(assurance.conducteur?.date_delivrance)
                this.loading = false
              },
              error : (err) =>{
                this.toastr.error("une erreur est survenue")
                this.loading = false
              }
            })
          }else{
            this.loading = false
          }
        },
        error : (err) =>{
          this.loading = false
        }
      })
  }

  loadGarantie(){

    if(this.inputData.update){
      this.selectedGarantieOrigin.push(...this.inputData.garanties!)
      this.selectedGarantie.push(...this.inputData.garanties!)

      this.assuranceService.listeGarantie().subscribe({
        next : (res) =>{
            this.garanties = res
            //this.selectedGarantie = this.garanties.filter(item => item.selected)
            //this.selectedGarantieOrigin = this.selectedGarantie.slice()

            this.garantieList.update((g) => res.map(item => {
              if(this.selectedGarantie.findIndex(val => val.abbreviation == item.abbreviation) != -1){
                return {
                  id : item.abbreviation,
                  name : item.name,
                  selected : true,
                  disabled : !item.status
                }
              }else{
                return {
                  id : item.abbreviation,
                  name : item.name,
                  selected : item.selected,
                  disabled : !item.status
                }
              }

            }))

            this.garantieList().forEach(item =>this.assuranceForm.get('garantie')?.get(item.id)?.setValue(item.selected))

        },
        error : (err) => {}
      })
    }else{
      this.assuranceService.listeGarantie().subscribe({
        next : (res) =>{
            this.garanties = res
            this.selectedGarantie = this.garanties.filter(item => item.selected)
            this.selectedGarantieOrigin = this.selectedGarantie.slice()

            this.garantieList.update((g) => res.map(item => {
              if(this.inputData.data?.remorque){
                return {
                  id : item.abbreviation,
                  name : item.name,
                  selected : item.selected,
                  disabled : true
                }
              }else{
                return {
                  id : item.abbreviation,
                  name : item.name,
                  selected : item.selected,
                  disabled : !item.status
                }
              }

            }))

            this.garantieList().forEach(item =>this.assuranceForm.get('garantie')?.get(item.id)?.setValue(item.selected))
            this.loading = false
        },
        error : (err) => this.loading = false
      })
    }

  }

  range(nbre : number){
    return new Array(nbre)
  }

  onSave(){

  }

  selectCompagnie(){

    const data : ModalListItemI = {
      title : "Compagnies",
      data : this.compagniesListe
    }

    const dialogRef = this.dialog.open(ListModalComponent, {
      width : '700px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : ListItem) => {

      if (result.id != '') {
        console.log(result);
        this.currentCompagnie = (this.dataOrigin.compagnies.filter(item => item.compagnie_id == result.id))[0]
        this.assuranceForm.get('compagnie_id')?.setValue(result.id)
        this.assuranceForm.get('compagnie_name')?.setValue(result.name)
        //clear fields
        this.assuranceForm.get('type')?.setValue('')
        this.assuranceForm.get('attestation')?.setValue('')
        this.assuranceForm.get('carte_rose')?.setValue('')

        //set type liste
        /*this.typeListe.splice(0, this.typeListe.length)
        this.typeListe.push(...this.typeListeOrigine.filter(item => item.compagnie_id == result.id))

        //active select type
        this.assuranceForm.get('type')?.enable()*/
      }
    });
  }

  onSetType(cat : number){
    const comp = this.assuranceForm.get('compagnie_id')?.value
    console.log(comp);

    if(comp == ''){
      this.toastr.war("Veuillez selectionner une compagnie")
      this.assuranceForm.get('categorie')?.reset()
      return;
    }
    const catAuto = [1, 2, 3, 6, 7, 8, 9 ,10]
    const catTaxi = [4]
    const catMoto = [5]
    if(catAuto.indexOf(cat) != -1){
      this.assuranceForm.get('type')?.setValue('A')
      this.assuranceForm.get('type_name')?.setValue('Automobile')
      this.onSelectedType('A')
    }else if(catTaxi.indexOf(cat) != -1){
      this.assuranceForm.get('type')?.setValue('T')
       this.assuranceForm.get('type_name')?.setValue('Taxi')
      this.onSelectedType('T')
    }else{
      this.assuranceForm.get('type')?.setValue('M')
       this.assuranceForm.get('type_name')?.setValue('Motocyclette')
      this.onSelectedType('M')
    }
  }

  onSelectedType(type : string){
    //filter le stocks
    const compagnie = this.assuranceForm.get('compagnie_id')?.value
    this.assuranceForm.get('attestation')?.setValue('')
    this.assuranceForm.get('carte_rose')?.setValue('')
    const dataStock = []
    console.log(this.stocks);
    dataStock.push(...this.stocks.filter(item => item.type == type && item.compagnie_id == compagnie))
    this.currentStock = dataStock.slice()

    if(dataStock.length == 0){
      this.toastr.war("Aucun documents pour ce type")
      this.toastr.info("Veuillez vous ravitailler")
      this.attestationList.splice(0, this.attestationList.length)
      this.carteRoseList.splice(0, this.carteRoseList.length)
      return;
    }
    console.log(dataStock);

    //attestation
    this.attestationList.splice(0, this.attestationList.length)
    dataStock.forEach(item =>{
      const range = (item.attestation_range?.split("-"))?.map(item => parseInt(item))??[]
      const rangeUsed = (item.attestation_used?.split(","))?.map(item => (item))??[]
      for (let index = range[0]; index < (range[1]+1); index++) {
          const att = this.currentCompagnie.compagnie_code+'*'+type+'*'+index.toString().padStart(7, '0')
          if(rangeUsed.indexOf(att) != -1)
            continue;
          this.attestationList.push({id : item.id, name : att})
      }
    })

    //carte rose
    this.carteRoseList.splice(0, this.carteRoseList.length)
    dataStock.forEach(item =>{
      const range = (item.carte_rose_range?.split("-"))?.map(item => parseInt(item))??[]
      const rangeUsed = (item.carte_rose_used?.split(","))?.map(item => parseInt(item))??[]
      for (let index = (range[0]); index < (range[1]+1); index++) {
          if(rangeUsed.indexOf(index) != -1)
            continue;
          const cr = index.toString()
          this.carteRoseList.push({id : item.id, name : cr})
      }
    })
  }

  selectAttestation(){

    const data : ModalListItemI = {
      title : "N* Attestation",
      data : this.attestationList
    }

    const dialogRef = this.dialog.open(ListModalComponent, {
      width : '700px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : ListItem) => {

      if (result.id != '') {
        console.log(result);
        this.assuranceForm.get('stock_attestation')?.setValue(result.id)
        this.assuranceForm.get('attestation')?.setValue(result.name)
        this.assuranceForm.get('partenaire')?.setValue(this.currentStock.find(item => item.id == result.id)?.partenaire_id)

      }
    });
  }

  selectCarteRose(){
    const data : ModalListItemI = {
      title : "N* Carte rose",
      data : this.carteRoseList
    }

    const dialogRef = this.dialog.open(ListModalComponent, {
      width : '700px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : ListItem) => {

      if (result.id != '') {
        console.log(result);
        this.assuranceForm.get('stock_carte_rose')?.setValue(result.id)
        this.assuranceForm.get('carte_rose')?.setValue(result.name)
      }
    });
  }

  setEndDate(p : string){
    const periode = parseInt(p)!
    if(periode == 0 || periode == undefined)return;
    const date = new Date(this.assuranceForm.get('date_effet')?.value)
    date.setDate(date.getDate() + (periode - 1)!)

    this.assuranceForm.get('date_fin')?.setValue(date)
  }

  getIdItemList(data : ListItem[]){

    this.selectedGarantie.splice(2, this.selectedGarantie.length)

    if(data.length == 0){
      this.assuranceForm.get('garantie')?.reset()
      //this.selectedGarantie.push(...this.selectedGarantieOrigin)
    }

    data.forEach(item =>{
        this.assuranceForm.get('garantie')?.get(item.id)?.setValue(true)
        this.selectedGarantie.push(...this.garanties.filter(elt => elt.abbreviation == item.id))
    })

    this.selectedGarantie.forEach(item =>{
      const garanties : string[] = ["dta", "dpc", "bdg", "vp", "vol", "bra", "inc", 'ar']
      if(garanties.includes(item.abbreviation)){
        this.showDetailsGarantie.update(val => true)
        this.assuranceForm.get('valeurs')?.get('valeur_neuve')?.setValidators(Validators.required)
        this.assuranceForm.get('valeurs')?.get('valeur_venale')?.setValidators(Validators.required)
        return;
      }
      this.assuranceForm.get('valeurs')?.get('valeur_neuve')?.setErrors(null)
      this.assuranceForm.get('valeurs')?.get('valeur_venale')?.setErrors(null)
      this.showDetailsGarantie.update(val => false)
    })

  }

  updateTypeDoc(val : boolean ,type : string){
    if(val && type == 'M'){
      this.assuranceForm.get('type')?.setValue('M')
      this.assuranceForm.get('type_name')?.setValue('Motocyclette')
      this.onSelectedType('M')
    }else{
      this.assuranceForm.get('type')?.setValue('A')
      this.assuranceForm.get('type_name')?.setValue('Automobile')
      this.onSelectedType('A')
    }
  }

  /*tarification(){
    this.loading = true

    const data : TarificationCheck = {
      categorie : this.assuranceForm.get('categorie')?.value,
      zone : this.assuranceForm.get('zone')?.value,
      periode : this.assuranceForm.get('periode')?.value,
      energie : this.inputData.data?.energie??'',
      puissance : this.inputData.data?.puissance??1,
      place : this.inputData.data?.place??0,
      cylindree : this.inputData.data?.cylindree??0,
      charge : (this.inputData.data?.charge_vide! + this.inputData.data?.charge_utile!),
      garanties : this.selectedGarantie,
      reduction : this.assuranceForm.get('reduction')?.value
    }

    this.assuranceService.checkTarification(data).subscribe({
      next : (res) =>{
        this.loading = false
        this.dataCalculPrime.update(prime => res)
        this.assuranceForm.get('confirm')?.get('confirm')?.setValue('confirm')
      },
      error : (err) =>{
        this.toastr.error("Une erreur est survenue lors du calcul de la prime")
      }
    })
    console.log(data);

  }*/

  resetDetails(cat : number){
    switch (cat) {
      case 7:
        this.assuranceForm.get('detailsCat7')?.get('doubleCom')?.setValue(false)
        this.assuranceForm.get('detailsCat7')?.get('rce')?.setValue(false)
        break;

      case 8:
        this.assuranceForm.get('detailsCat8')?.get('moins3_5t')?.setValue(false)
        this.assuranceForm.get('detailsCat8')?.get('plus3_5t')?.setValue(false)
        break;
      case 10:
        this.assuranceForm.get('detailsCat10')?.get('ambulance')?.setValue(false)
        this.assuranceForm.get('detailsCat10')?.get('corbillard')?.setValue(false)
        this.assuranceForm.get('detailsCat10')?.get('fourgon')?.setValue(false)
        this.assuranceForm.get('detailsCat10')?.get('poidsSuperieur')?.setValue(false)
        this.assuranceForm.get('detailsCat10')?.get('poidsInferieur')?.setValue(false)
        break;

      default:
        break;
    }
  }

  loadDetails(data : any) : boolean{

    let detailState = true

    const cat = this.assuranceForm.get('categorie')?.value
    data.details = this.assuranceForm.get('detailsCat' + cat)?.value

    if(data.details == null){
      return true;
    }

    const dd = (Object.values(data.details!) as boolean[])??[]
    let state = false;
    dd.forEach(item => {if(item)state=true})

    switch (cat) {

      case 5:

          /*
          dd.forEach(item => {if(item)state=true})
          if(!state){
            this.loadingPrevu.update(l => false)
            this.toastr.war("Veuillez renseigner les details de la categorie : "+data.categorie)
            detailState =  false
          }*/
        break

      case 6:
          //data.details = this.assuranceForm.get('detailsCat6')?.value

        break
      case 7:
        //data.details = this.assuranceForm.get('detailsCat7')?.value
        if(!state){
          this.loadingPrevu.update(l => false)
          this.toastr.war("Veuillez renseigner les details de la categorie : "+cat)
          detailState =  false
        }
        if(data.details['utilitaire'] || data.details['tourisme']){
          this.loadingPrevu.update(l => false)
          if(!data.details['doubleCom'] && !data.details['rce']){
              this.toastr.war("Veuillez selectionner la double commande ou R.C Eleve")
              detailState = false
          }
        }
        break;

      case 8:
        //data.details = this.assuranceForm.get('detailsCat8')?.value
        if(!state){
          this.loadingPrevu.update(l => false)
          this.toastr.war("Veuillez renseigner les details de la categorie : "+cat)
          detailState =  false
        }
        if(data.details['utilitaire']){
          this.loadingPrevu.update(l => false)
          if(!data.details['moins3_5t'] && !data.details['plus3_5t']){
              this.toastr.war("Veuillez selectionner moins de 3.5T ou plus de 3.5T")
              detailState = false
          }
        }
        break;
      case 9:
        if(!state){
          this.loadingPrevu.update(l => false)
          this.toastr.war("Veuillez renseigner les details de la categorie : "+cat)
          detailState =  false
        }
        break;
      case 10:
        if(!state){
          this.loadingPrevu.update(l => false)
          this.toastr.war("Veuillez renseigner les details de la categorie : "+cat)
          detailState =  false
        }
        if(data.details['categorie10a']){
          this.loadingPrevu.update(l => false)
          if(!data.details['ambulance'] && !data.details['fourgon'] && !data.details['corbillard']){
              this.toastr.war("Veuillez selectionner les details de l'option categorie 10 A")
              detailState = false
          }
        }else if(data.details['collectivite']){
           this.loadingPrevu.update(l => false)
          if(!data.details['poidsInferieur'] && !data.details['poidsSuperieur']){
              this.toastr.war("Veuillez selectionner les details de l'option Vehicule de collectivite publique ")
              detailState = false
          }
        }
        break;

    }

    return detailState
  }

  imprimerAppercu(){
    this.assuranceForm.get('valeurs')?.get('valeur_neuve')?.setValidators(Validators.required)
    this.assuranceForm.get('valeurs')?.get('valeur_venale')?.setValidators(Validators.required)

    this.loadingPrevu.update(l => true)
    const data = {
      details : null,
      garanties : this.selectedGarantie,
      valeur_neuve : this.assuranceForm.get('valeurs')?.get('valeur_neuve')?.value,
      valeur_venale : this.assuranceForm.get('valeurs')?.get('valeur_venale')?.value,
      conducteur : this.assuranceForm.get('conducteur')?.value,
      vehicule_id : (this.inputData.data?.id) || (this.inputData.assurance?.vehicule),
      tracteur_id : (this.inputData.data?.tracteur_id)??"",
      remorque : (this.inputData.data?.remorque)??false,
      assure_id : (this.inputData.assure?.id) || (this.inputData.assurance?.assure),
      puissance : this.assuranceForm.get('puissance')?.value,
      energie : this.assuranceForm.get('energie')?.value,
      cylindree : this.assuranceForm.get('cylindree')?.value,
      compagnie_id : this.assuranceForm.get('compagnie_id')?.value,
      assurance_id : this.inputData.assurance_id,
      assurance : {
        id : this.currentAssuranceId,
        attestation : this.assuranceForm.get('attestation')?.value,
        carte_rose : this.assuranceForm.get('carte_rose')?.value,
        reduction : this.assuranceForm.get('reduction')?.value,
        type : this.assuranceForm.get('type')?.value,
        date_effet : formatDate(this.assuranceForm.get('date_effet')?.value, "yyyy-MM-dd", this.locale),
        date_fin : formatDate(this.assuranceForm.get('date_fin')?.value, "yyyy-MM-dd", this.locale),
        periode : this.assuranceForm.get('periode')?.value,
        categorie : this.assuranceForm.get('categorie')?.value,
        zone : this.assuranceForm.get('zone')?.value,
        vignette_exonere : this.assuranceForm.get('vignette_exonere')?.value,
        vignette_paye : this.assuranceForm.get('vignette_paye')?.value,
        licence : this.assuranceForm.get('licence_transport')?.value,
      },
      avenant : this.inputData.update,
      partenaire : this.assuranceForm.get('partenaire')?.value
    }

    if(!this.loadDetails(data)){
      this.loadingPrevu.update(l => false)
      return;
    }


    this.pdfService.getDocument(data).subscribe({
      next: (blob: Blob) => {
        this.loadingPrevu.update(l => false)

        const data : PrintData ={
          assurance : this.inputData.assurance_id!,
          name : "appercu-contrat",
          dataBlob : blob
        }
        const dialogRef = this.dialog.open(PrintComponent, {
          width : '1200px',
          enterAnimationDuration : '500ms',
          exitAnimationDuration : '500ms',
          disableClose : true,
          data : data
        });

          // 1. Créer une URL sécurisée pour le flux binaire (PDF)
          /*const blobUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));

          // 2. Ouvrir dans un nouvel onglet
          const win = window.open(blobUrl, '_blank');

          // 3. Optionnel : Forcer le focus si la fenêtre a été ouverte
          if (win) {
            win.focus();
          }

          // 4. Nettoyage de la mémoire (important pour les gros fichiers)
          setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);*/

      },
      error: (err) => {
        this.loadingPrevu.update(l => false)
        console.error('Erreur de téléchargement', err)
      }
    });
  }

  onConfirmSaveContrat(){
    this.sweetAlert.confirm("Etez-vous sur de vouloir valider cette assurance")
    .then((res) =>{
      if(res.isConfirmed){
        this.onSaveContrat()
      }

    })
  }

  onSaveContrat(){
    this.saveLoading.update(val => true)

    const data = {
      assurance : this.currentAssuranceId,
      categorie : this.assuranceForm.get('categorie')?.value,
      details : null,
      zone : this.assuranceForm.get('zone')?.value,
      periode : this.assuranceForm.get('periode')?.value,
      date_effet : formatDate(this.assuranceForm.get('date_effet')?.value, "yyyy-MM-dd", this.locale),
      date_fin : formatDate(this.assuranceForm.get('date_fin')?.value, "yyyy-MM-dd", this.locale),
      vehicule : (this.inputData.data?.id) || (this.inputData?.assurance?.vehicule),
      assure : (this.inputData.assure?.id) || (this.inputData?.assurance?.assure),
      conducteur_id : this.inputData.assurance?.conducteur?.id,
      conducteur : this.assuranceForm.get('conducteur')?.value,
      garanties : this.selectedGarantie,
      valeur_neuve : this.assuranceForm.get('valeurs')?.get('valeur_neuve')?.value,
      valeur_venale : this.assuranceForm.get('valeurs')?.get('valeur_venale')?.value,
      reduction : this.assuranceForm.get('reduction')?.value,
      compagnie : this.assuranceForm.get('compagnie_id')?.value,
      attestation : this.assuranceForm.get('attestation')?.value,
      carte_rose : this.assuranceForm.get('carte_rose')?.value,
      type : this.assuranceForm.get('type')?.value,
      stock_attestation : this.assuranceForm.get('stock_attestation')?.value,
      stock_carte_rose : this.assuranceForm.get('stock_carte_rose')?.value,
      vignette_exonere : this.assuranceForm.get('vignette_exonere')?.value,
      vignette_paye : this.assuranceForm.get('vignette_paye')?.value,
      licence : this.assuranceForm.get('licence_transport')?.value,
      tracteur_id : (this.inputData.data?.tracteur_id)??"",
      remorque : (this.inputData.data?.remorque)??false,
      puissance : this.assuranceForm.get('puissance')?.value,
      energie : this.assuranceForm.get('energie')?.value,
      cylindree : this.assuranceForm.get('cylindree')?.value,
      partenaire : this.assuranceForm.get('partenaire')?.value
    }

    if(!this.loadDetails(data)){
      this.saveLoading.update(val => false)
      return;
    }

    this.assuranceService.saveAssurance(data).subscribe({
      next : (res) =>{
        console.log(res);
        this.saveLoading.update(val => false)
        this.toastr.success("Assurance etablie")
        this.dialogRef.close(res)
      },
      error : (err) =>{
        this.toastr.error((err.error.message)??"une erreur est survenue")
        this.saveLoading.update(val => false)
      }
    })
  }

  /*onSaveRemorque(){
    this.saveLoading.update(val => true)

    const data = {
      assurance_id : this.inputData.assurance_id,
      attestation : this.assuranceForm.get('attestation')?.value,
      carte_rose : this.assuranceForm.get('carte_rose')?.value,
      stock_attestation : this.assuranceForm.get('stock_attestation')?.value,
      stock_carte_rose : this.assuranceForm.get('stock_carte_rose')?.value,
      type : this.assuranceForm.get('type')?.value,
      categorie : this.assuranceForm.get('categorie')?.value,
      details : null,
      garanties : this.selectedGarantie,
      remorque : this.assuranceForm.get('remorque')?.value,
      reduction : this.assuranceForm.get('reduction')?.value
    }

    if(!this.loadDetails(data))
      return;

    this.assuranceService.joinTrailer(data).subscribe({
      next : (res) =>{
        console.log(res);
        this.saveLoading.update(val => false)
        this.toastr.success("Assurance etablie")
        this.dialogRef.close(res)
      },
      error : (err) =>{
        this.toastr.error((err.error.message)??"une erreur est survenue")
        this.saveLoading.update(val => false)
      }
    })
  }*/

}
